import IncomeStatementActions from './actions';

const INITIAL_STATE = {
  data: {},
  isProcessing: false,
  isError: false,
  errorMessage: [],
  form:{},
  isNewRecord:false,
  showModal:false,
  onSubmit:false,
  single:null,
  helperIncomeStatement:[],
  errorInternal:false,
  printIncomeStatement:null
};

function IncomeStatementReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case IncomeStatementActions.RESET_LIST:
      return { ...state,errorInternal:false,onSubmit:false, isProcessing: false,single:null, form:INITIAL_STATE.form,data:{}};
    case IncomeStatementActions.NEW_DATA:
      return { ...state,errorInternal:false,onSubmit:false, isProcessing: false,single:null, errorMessage:[],form:INITIAL_STATE.form,isNewRecord:true,showModal:true};
    case IncomeStatementActions.UPDATE_DATA:
      return { ...state, errorInternal:false,onSubmit:false,isProcessing: false, single:null,isNewRecord:false};
    case IncomeStatementActions.VIEW_DATA:
      return { ...state, errorInternal:false,onSubmit:false,isProcessing: false, single:action.payload,errorMessage:[],isNewRecord:false,showModal:true};
    case IncomeStatementActions.RESET_DATA:
      return { ...state,errorInternal:false,onSubmit:false, isProcessing: false, form:INITIAL_STATE.form,showModal:false};
    case IncomeStatementActions.DELETE_DATA:
      return { ...state, errorInternal:false,onSubmit:false,isProcessing: false, form:INITIAL_STATE.form,showModal:false};
    case IncomeStatementActions.ON_SUBMIT:
      return { ...state, errorInternal:false,onSubmit:true};
    case IncomeStatementActions.SHOW_DATA:
      return { ...state, errorInternal:false,onSubmit:false, isError: false, data: action.payload, errorMessage: [],isProcessing:false };
    case IncomeStatementActions.ERROR_DATA:
      return { ...state, errorInternal:false, isError: true,onSubmit:false,  errorMessage: action.payload,isProcessing:false };
    case IncomeStatementActions.SUCCESS_DATA:
      return { ...state,errorInternal:false,onSubmit:false, isError: false, showModal:false,form:INITIAL_STATE.form , onSubmit:false};
    case IncomeStatementActions.PROCESS_DATA:
      return { ...state, errorInternal:false,onSubmit:false,isProcessing: true, isError: false,isSuccess:false};
    case IncomeStatementActions.GET_HELPER_INCOMESTATEMENT:
      return { ...state,errorInternal:false, isError: false,isSuccess:false,onSubmit:false,helperIncomeStatement:action.payload};
    case IncomeStatementActions.ERROR_SERVER:
      return { ...state,  isError: false, errorInternal:true, onSubmit:false,  errorMessage: action.payload, isProcessing:false };
    case IncomeStatementActions.BEFORE_PRINT_INCOMESTATEMENT:
      return { ...state,errorInternal:false,  isError: false,isSuccess:false,onSubmit:false,printIncomeStatement:null,isProcessing:true};
    case IncomeStatementActions.PRINT_INCOMESTATEMENT:
      return { ...state,errorInternal:false,  isError: false,isSuccess:false,onSubmit:false,printIncomeStatement:action.payload,isProcessing:false};
        
    default:
      return state;
    }
}

export default IncomeStatementReducer;
